/**CORE LIBRARIES IMPORT */
import { useEffect, useRef, useState } from "react";

/**
 * Same behaviour the template used inline in AboutUs/DJ: flips to true the
 * first time the element is `threshold` visible, then stops observing.
 * Drives the gradient underline on `.section-heading.in-view`.
 */
export default function useInViewOnce(threshold = 0.5) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView];
}
